import { useMemo } from 'react';
import {
  Typography,
  TypographyVariants,
  TypographyWeights,
  TypographyColors,
} from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { FieldSection } from '@/components/common';
import {
  buildAllocationQuantitySections,
  buildAllocationAdditionalFields,
  buildAllocationPreferenceFields,
} from '../constants/allocationOverviewFields';
import styles from './AllocationOverviewTabView.module.scss';

/**
 * Props:
 *   allocation  the allocation detail view model
 */
export const AllocationOverviewTabView = ({ allocation }) => {
  const t = useTranslations();

  const quantitySections = useMemo(
    () => buildAllocationQuantitySections(t, allocation),
    [t, allocation],
  );
  const additionalFields = useMemo(
    () => buildAllocationAdditionalFields(t, allocation),
    [t, allocation],
  );
  const preferenceFields = useMemo(
    () => buildAllocationPreferenceFields(t, allocation),
    [t, allocation],
  );

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <Typography
          variant={TypographyVariants.bodySm}
          weight={TypographyWeights.semibold}
          color={TypographyColors.primary}
        >
          {t('SECTION_OVERVIEW')}
        </Typography>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.quantityColumn}>
          {quantitySections.map((section) => (
            <FieldSection key={section.heading} heading={section.heading} fields={section.fields} />
          ))}
        </div>
        <FieldSection heading={t('SECTION_ADDITIONAL_DETAILS')} fields={additionalFields} />
        <FieldSection heading={t('SECTION_PREFERENCES')} fields={preferenceFields} />
      </div>
    </div>
  );
};
